function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.915 2.676l.409.408-4.026 4.027h-.41v-.409l4.027-4.026zM6.515 0a.445.445 0 00-.311.129L5.39.942 7.057 2.61l.813-.813a.443.443 0 000-.627L6.83.129A.436.436 0 006.515 0zm-1.6 1.418L0 6.333V8h1.666l4.915-4.916-1.666-1.666z",
  fill: "currentColor"
});

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "9355d97cdf3b3a04d00ac863e7d8730a.svg";
export { SvgPencil as ReactComponent };